import { inject as A, computed as N, ref as m, nextTick as j } from "vue";
import { datePickerInjectionKey as D } from "./ghl-ui.es966.js";
import K from "./ghl-ui.es716.js";
const L = "HH:mm:ss", w = {
  active: Boolean,
  dateFormat: String,
  timeFormat: {
    type: String,
    value: L
  },
  value: {
    type: [Array, Number],
    default: null
  },
  shortcuts: Object,
  defaultTime: [Number, String, Array],
  onClear: Function,
  onConfirm: Function,
  onClose: Function,
  onTabOut: Function,
  onUpdateValue: {
    type: Function,
    required: !0
  },
  themeClass: String,
  onRender: Function,
  panel: Boolean,
  onNextMonth: Function,
  onPrevMonth: Function,
  onNextYear: Function,
  onPrevYear: Function
};
function z(t) {
  const {
    dateLocaleRef: h,
    timePickerSizeRef: v,
    timePickerPropsRef: P,
    localeRef: F,
    mergedClsPrefixRef: C,
    mergedThemeRef: g
    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
  } = A(D), b = N(() => ({
    locale: h.value.locale
  })), a = m(null), r = K();
  function T() {
    const {
      onClear: e
    } = t;
    e && e();
  }
  function y() {
    const {
      onConfirm: e,
      value: n
    } = t;
    e && e(n);
  }
  function c(e, n) {
    const {
      onUpdateValue: o
    } = t;
    o(e, n);
  }
  function f(e = !1) {
    const {
      onClose: n
    } = t;
    n && n(e);
  }
  function i() {
    const {
      onTabOut: e
    } = t;
    e && e();
  }
  function k() {
    c(null, !0), f(!0), T();
  }
  function S() {
    i();
  }
  function R() {
    (t.active || t.panel) && j(() => {
      const {
        value: e
      } = a;
      if (!e)
        return;
      const n = e.querySelectorAll("[data-n-date]");
      n.forEach((o) => {
        o.classList.add("transition-disabled");
      }), e.offsetWidth, n.forEach((o) => {
        o.classList.remove("transition-disabled");
      });
    });
  }
  function O(e) {
    e.key === "Tab" && e.target === a.value && r.shift && (e.preventDefault(), i());
  }
  function V(e) {
    const {
      value: n
    } = a;
    r.tab && e.target === n && (n != null && n.contains(e.relatedTarget)) && i();
  }
  let s = null, l = !1;
  function p() {
    s = t.value, l = !0;
  }
  function M() {
    l = !1;
  }
  function d() {
    l && (c(s, !1), l = !1);
  }
  function x(e) {
    return typeof e == "function" ? e() : e;
  }
  const u = m(!1);
  function E() {
    u.value = !u.value;
  }
  return {
    mergedTheme: g,
    mergedClsPrefix: C,
    dateFnsOptions: b,
    timePickerSize: v,
    timePickerProps: P,
    selfRef: a,
    locale: F,
    doConfirm: y,
    doClose: f,
    doUpdateValue: c,
    doTabOut: i,
    handleClearClick: k,
    handleFocusDetectorFocus: S,
    disableTransitionOneTick: R,
    handlePanelKeyDown: O,
    handlePanelFocus: V,
    cachePendingValue: p,
    clearPendingValue: M,
    restorePendingValue: d,
    getShortcutValue: x,
    handleShortcutMouseleave: d,
    showMonthYearPanel: u,
    handleOpenQuickSelectMonthPanel: E
  };
}
export {
  z as usePanelCommon,
  w as usePanelCommonProps
};
